import {
  fetchActivityTypes,
  fetchActivityTypesLookup,
  createActivityType,
  editActivityType,
  changeActivityTypeActiveStatus,
} from '../routines';

const initialState = {
  activityTypeList: [],
  activityTypesLookup: {},
  isLoading: false,
  isLookupLoading: false,
};

const activityTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchActivityTypesLookup.TRIGGER:
      return {
        ...state,
        isLookupLoading: true,
      };
    case fetchActivityTypesLookup.SUCCESS:
      return {
        ...state,
        isLookupLoading: false,
        activityTypesLookup: action.payload.data,
      };
    case createActivityType.TRIGGER:
    case editActivityType.TRIGGER:
    case changeActivityTypeActiveStatus.TRIGGER:
    case fetchActivityTypes.TRIGGER:
      return {
        ...state,
        isLoading: true,
      };

    case fetchActivityTypes.SUCCESS:
      return {
        ...state,
        isLoading: false,
        activityTypeList: action.payload.data,
      };

    case editActivityType.FAILURE:
    case changeActivityTypeActiveStatus.FAILURE:
    case createActivityType.FAILURE:
    case editActivityType.SUCCESS:
    case changeActivityTypeActiveStatus.SUCCESS:
    case createActivityType.SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default activityTypeReducer;
